import "./wdyr";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initializeHotjar } from "./utils/hotjarUtils";
import { initializeTagManager } from "./utils/tagmanagerUtils";
import { polyfillBigInt } from "./utils/polyfillBigInt";
import { polyfillBuffer } from "./utils/polyfillBuffer";
initializeHotjar();
initializeTagManager();
polyfillBigInt();
polyfillBuffer();

const root = ReactDOM.createRoot(document.getElementById("root") ?? document.createElement("div"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
